/*
 * Marionette CollectionView: StatusListView
 * -------------------------
 * Displays a collection of status events
 */
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import StatusItemView from '@/views/status_item_view';

    var StatusListView = Marionette.CollectionView.extend({
        childView: StatusItemView,
        emptyView: Marionette.View,
        emptyViewOptions: {
            template: Handlebars.compile('<div class="status-item">None</div>')
        }
    });
    export default StatusListView;

